export default "__VITE_ASSET__2CYA_MMU__";